import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    marginTop: "0.5vh",
    height: "100%",
  },
  contentContainer: {
    marginTop: "6vh",
    justifyContent: "center",
    alignItems: "center",
  },
  heading: {
    color: "$description_heading_text",
    fontSize: "$description_heading_text_size",
    fontFamily: "$description_heading_text_style",
  },
  background: {
    opacity: "0.8",
    position: "absolute",
    zIndex: "0",
    width: "100%",
    height: "100%",
  },
});
